// 档案管理路由
//  权限：  楼宇管理：house、业主管理：business_owner、设备管理：terminal_device

const ArchivesMana = [
    // 添加建筑
    {
        path: '/residence',
        component: resolve => require(['@/views/ArchivesMana/AddBuilding/AddBuilding'], resolve),
        name: 'addConstruction',
        meta: { title: '建筑管理', breadcrumb: [{ menu: 'addConstruction', path: '/residence' }], role:'house' }
    },
    // 业主管理
    {
        path: '/household',
        component: resolve => require(['@/views/ArchivesMana/LesseeMana/LesseeMana'], resolve),
        name: 'householdMana',
        meta: { title: '业主管理', breadcrumb: [{ menu: 'householdMana' }], role: 'business_owner' },
    },
    // 添加业主
    {
        path: '/household/add',
        component: resolve => require(['@/views/ArchivesMana/LesseeMana/AddLessee/AddLessee'], resolve),
        name: 'addHousehold',
        meta: { title: '添加业主', breadcrumb: [{ menu: 'householdMana', path: "/household" }, { menu: 'addHousehold' }], role: 'business_owner' },
    },
	// 查询流水
	{
	    path: '/household/balancechange/:oid',
	    component: resolve => require(['@/views/ArchivesMana/LesseeMana/BalanceChange/BalanceChange'], resolve),
	    name: 'balanceChange',
	    meta: { title: '查询流水', breadcrumb: [{ menu: 'householdMana' ,path: "/household"}, { menu: 'balanceChange' }], role: 'business_owner' },
	},
    // 表计绑定
    {
        path: '/meter',
        component: resolve => require(['@/views/ArchivesMana/MeterBinding/BindMeter'], resolve),
        name: 'meterBinding',
        meta: { title: '表计绑定', breadcrumb: [{ menu: 'meterBinding' }], role: 'terminal_device' }
    },
    // 选择表计
    {
        path: '/meter/bind',
        component: resolve => require(['@/views/ArchivesMana/MeterBinding/ChooseMeter/ChooseMeter'], resolve),
        name: 'choseMeter',
        meta: { title: '选择表计', breadcrumb: [{ menu: 'meterBinding', path: "/meter" }, { menu: 'choseMeter' }] }
    },
    // 计费方案
    {
        path: '/setchargescheme',
        component: resolve => require(['@/views/ArchivesMana/SetChargeScheme/SetChargeScheme'], resolve),
        name: 'chargescheme',
        meta: { title: '计费方案', breadcrumb: [{ menu: 'chargescheme' }], role: 'business_owner' }
    },
    // 计费设置
    {
        path: '/setchargescheme/chargeset/:schemeId',
        component: resolve => require(['@/views/ArchivesMana/SetChargeScheme/ChargeSet/ChargeSet'], resolve),
        name: 'setCharge',
        meta: { title: '计费设置', breadcrumb: [{ menu: 'chargescheme', path: "/setchargescheme" }, { menu: 'setCharge' }], role: 'business_owner' }
    },
    // 价格设置
    {
        path: '/setchargescheme/priceset/:schemeId',
        component: resolve => require(['@/views/ArchivesMana/SetChargeScheme/PriceSet/PriceSet'], resolve),
        name: 'setPrice',
        meta: { title: '价格设置', breadcrumb: [{ menu: 'chargescheme', path: "/setchargescheme" }, { menu: 'setPrice' }], role: 'business_owner' }
    },
    // 欠费设置
    {
        path: '/setchargescheme/arrearageset/:schemeId',
        component: resolve => require(['@/views/ArchivesMana/SetChargeScheme/ArrearageSet/ArrearageSet'], resolve),
        name: 'arrearageset',
        meta: { title: '欠费设置', breadcrumb: [{ menu: 'chargescheme', path: "/setchargescheme" }, { menu: 'arrearageset' }], role: 'business_owner' }
    },
];

export default ArchivesMana